import './home.css';
import youlvkexun from '../res/youlvkexun_ad.png';
import {
    BrowserRouter,
    Routes,
    Route,
    Link
  } from "react-router-dom";
  import { Button } from 'antd';


export const  Home = () => {
    console.log("------>");

    const download = ()=>{
        window.open("http://ylkx.lvshiguan.com/ylkx.release.apk");
    }

  return (
    <div className="container">

      <main className="main">
        <div className="RootContainer">
          <div>
            <div className="DevInfo">
              <div className="DevIntoItem">
                开发者：湖南有律可寻网络科技有限公司
              </div>
              <div className="DevIntoItem">
              
                 <Link to="/app_private">应用权限</Link>|  <Link to="/user_privacy">隐私政策</Link>
              
              </div>
              <div className="DevIntoItem">
                应用名称：有律可寻
              </div>
              <div className="DevIntoItem">
                应用名称：应用版本：1.0|更新时间：2021/11/25.
              </div>
            </div>
            <img src={youlvkexun} className="DevPic"></img>
          </div>
            <Button onClick={download} style={{position:"absolute", bottom:"50px", fontSize:"20px",height:"50px",width:"calc( 100% - 160px )" }} size={"large"} type="primary"  danger>下载app</Button>
        </div>
     
      </main>

     
    </div>
  )
}
